import { Card, Table, TableBody, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataRow, DateDisplay } from 'app/components';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import TitleField from '../TitleField';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },
  title: {
    paddingLeft: theme.spacing(2),
    fontWeight: 'bold',
  },
  subTitle: {
    fontWeight: 'bold',
  },
  table: {
    padding: 0,
  },
  small: {
    fontSize: 12,
    color: theme.palette.grey.primary,
  },
}));

const SumsubFieldTable = (props) => {
  const { datafield, className } = props;

  // console.log('datafield: ', datafield);

  const [data, setData] = useState();

  const classes = useStyles();

  useEffect(() => {
    if (datafield) {
      const fields = [
        { title: 'Date Created', value: datafield.createDate || '' },
        { title: 'Date Reviewed', value: datafield.reviewDate || '' },
        { title: 'Review Status', value: datafield.reviewStatus || '' },
        { title: 'Review Result', value: datafield.reviewResult.reviewAnswer === 'GREEN' ? 'ACCEPTED' : 'REJECTED' || '' },
        { title: 'Review Attempts', value: datafield.attemptCnt || '' },
        { title: 'Rejection Reason', value: datafield.reviewResult.moderationComment || '' },
      ];
      setData(fields);
    }
  }, [datafield]);

  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>Verification Details</TitleField>
      {
        <Table className={classes.table}>
          <TableBody>
            {data &&
              data.map(
                (field, id) =>
                  field.value && (
                    <DataRow
                      key={id}
                      name={
                        <>
                          <Typography className={classes.subTitle} color="secondary" variant="body1">
                            {field.title}
                          </Typography>

                          {field.type === 'array' ? (
                            field.value.map((item, index) => {
                              return (
                                <>
                                  <br />
                                  <Typography>{`${field.title} ${index + 1}`}</Typography>
                                  {Object.keys(item).map((key) => (
                                    <Typography color="secondary" key={index}>
                                      {item[key]}
                                    </Typography>
                                  ))}
                                </>
                              );
                            })
                          ) : (
                            <Typography color="secondary">{field.value}</Typography>
                          )}
                        </>
                      }
                    />
                  )
              )}
          </TableBody>
        </Table>
      }
    </Card>
  );
};

export default SumsubFieldTable;
